( function( $ ) {
	'use strict';

	$( function() {
        const $trigger = $( '.js-dropdown-trigger' );
		const activeClass   = 'is-active';

        $trigger.on( 'click', function( e ) {
            e.stopPropagation();
            $( this ).toggleClass( activeClass );
        } );

        $( document ).on( 'click', function( e ) {
            if ( !$trigger.is( e.target ) && $trigger.has( e.target ).length === 0 && $trigger.hasClass( activeClass ) ) {
                $trigger.removeClass( activeClass );
            }
        } );
	} );
} )( jQuery );
